export default "__VITE_ASSET__Bogl3UWM__"